export const fitInstructions: Record<string, string> = {
  Heroes:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Garment-dyed stretch cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Heroes - Tapered':
    'Slim fit, with a sharper taper | Mid-rise — sits just below the waist | Garment-dyed stretch cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Heritage Heroes':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Military fatigue style twill | 2% stretch | Want to roll the hem? Add an inch to your usual leg length ',
  'Winter Heroes':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Warm brushed cotton  | Want to roll the hem? Add an inch to your usual leg length ',
  Sharps:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Sharps - Tapered':
    'Slim fit, with a sharper taper | Mid-rise — sits just below the waist | Garment-dyed stretch cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Summer Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Featherweight stretch cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Linen Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Linen-cotton-elastane blend | Want to roll the hem? Add an inch to your usual leg length ',
  'Cord Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch needlecord | Want to roll the hem? Add an inch to your usual leg length ',
  'Velvet Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch velvet | Want to roll the hem? Add an inch to your usual leg length ',
  'Cashmere Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian cotton-cashmere blend | Want to roll the hem? Add an inch to your usual leg length ',
  Fives:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Lyocell-elastane-cotton blend | Want to roll the hem? Add an inch to your usual leg length ',
  'Moleskin Fives':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Moleskin with 3% stretch | Want to roll the hem? Add an inch to your usual leg length ',
  'Cord Fives':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian corduroy | Want to roll the hem? Add an inch to your usual leg length ',
  Smarts:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | 100% Italian wool | Want to roll the hem? Add an inch to your usual leg length ',
  'Winter Smarts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Want to roll the hem? Add an inch to your usual leg length ',
  'Santa Pants':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Drawstring stretch waistband | Reindeer not included | Want to roll the hem? Add an inch to your usual leg length ',
  'Summer Smarts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Smooth cotton blend | Want to roll the hem? Add an inch to your usual leg length ',
  Hackneys:
    'Wide fit with a light taper | Higher rise — sits on the waist | Herringbone stretch weave | British forward pleats | Want to roll the hem? Add an inch to your usual leg length ',
  'Cord Hackneys':
    'Wide fit with a light taper | Higher rise — sit on the waist | Stretch corduroy | British forward pleats | Want to roll the hem? Add an inch to your usual leg length ',
  'Jumbo Cord Hackneys':
    'Wide fit with a light taper | Higher rise — sit on the waist | Jumbo stretch corduroy | British forward pleats | Want to roll the hem? Add an inch to your usual leg length ',
  Nomads:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Drawstring waist | Lightweight stretch cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Seersucker Nomads':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Drawstring waist | Lightweight stretch seersucker cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Bulletproofs - Legacy':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | 2-way stretch | Water-resistant cotton | Want to roll the hem? Add an inch to your usual leg length ',
  Cargos:
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Want to roll the hem? Add an inch to your usual leg length ',
  'Linen Hackneys':
    'Wide fit with a light taper | Higher rise — sits on the waist | Linen-cotton-elastane blend | British forward pleats | Want to roll the hem? Add an inch to your usual leg length ',
  'Linen Nomads':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Drawstring waist | Lightweight stretch cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Travel Denim':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Hyper-stretch denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Original Denim':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Mid-weight stretch denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Original Denim - Tapered':
    'Slim fit, with a sharper taper | Mid-rise — sits just below the waist | Garment-dyed stretch cotton | Want to roll the hem? Add an inch to your usual leg length ',
  'Hemp Denim':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | 14oz stretch denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Selvedge Denim':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | 14oz stretch denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Italian Denim':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Mid-weight stretch denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Winter Travel Denim':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Hyper-stretch mid-weight denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Stonewash Denim':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Mid-weight stretch denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Denim Heroes':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Mid-weight stretch denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Japanese Denim':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | 14oz Japanese denim | Want to roll the hem? Add an inch to your usual leg length ',
  'Cotton Oxford':
    'Essential smart-casual Oxford | Soft stretch cotton ',
  'Flannel Shirt':
    'Smart-casual Oxford style | Soft brushed cotton ',
  'Linen Shirt':
    'Smart-casual Oxford style | Breezy linen ',
  'Cord Shirt':
    'Smart-casual Oxford style | Soft Italian stretch corduroy ',
  'Pique Polo':
    'Soft Portuguese stretch cotton | Smart-casual sweetspot ',
  'Original Tee': 'Soft organic cotton ',
  Tolo: 'Soft, smooth, Portuguese stretch cotton | Smart-casual sweetspot ',
  'Heavyweight T-Shirt':
    'Heavier weight 240gsm cotton | Organic Portuguese cotton ',
  'Long Sleeve Tee':
    'Organic stretch-cotton | Reinforced sleeve hems ',
  'Cashmere Half-Zip': '100% cashmere ',
  'The Jack': 'Soft stretch cotton ',
  'The Cord Jack':
    'Wide wale corduroy | 100% cotton ',
  'Enduro Jack': 'High-tech stretch fabric ',
  'Slub Tee': 'Ultra-light 100% slub cotton ',
  'Button-Through Polo':
    '100% knitted cotton ',
  'Seersucker Cuban': '',
  'Merino Crew': '',
  'Merino Polo': '',
  'Merino Half-Zip': '',
  'Knit Tee':
    'Breezy cotton-linen-stretch blend ',
  'Cuban Shirt':
    '100% linen | Classic camp collar | Relaxed fit — pick your regular size ',
  'Revere Polo':
    'Breezy 100% cotton | Relaxed open V Collar ',
  'Ripple Cotton Shirt':
    'Smart-casual Oxford style | Soft ripple cotton ',
  'The Summer Jack': 'Soft stretch cotton ',
  'Sharp Shorts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch cotton ',
  'Milano Shorts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Soft Italian stretch cotton | Rolling up? Go for a longer length. ',
  'Hero Shorts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Garment-dyed stretch cotton | Rolling up? Go for a longer length. ',
  Swims:
    'Mid-rise — sits just below the waist | Quick-dry Portuguese polyamide ',
  'Action Swims':
    'Mid-rise — sits just below the waist | Quick-dry Portuguese polyamide | Comfortable compression lining ',
  'Nomad Shorts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Italian stretch cotton ',
  'Linen Nomad Shorts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Linen-cotton-elastane blend ',
  'Cord Nomad Shorts':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | Soft Italian stretch corduroy ',
  'Hackney Shorts':
    'Wide fit | Higher-rise — sits at the waist | Stretch cotton ',
  'Enduro Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | High-tech non-iron fabric ',
  'Enduro Tee':
    'Choose from three lengths and two chest sizes ',
  'Enduro Shirt':
    'Choose from three lengths and two chest sizes ',
  'Enduro Fives':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | High-tech non-iron fabric ',
  'Enduro Tech Sharps':
    'Slim fit — but not skinny | Mid-rise — sits just below the waist | High-tech non-iron fabric ',
  'Box Tee':
    'Heavier weight 240gsm cotton | Oversized fit | Organic Portuguese cotton '
}

export const fitInstructionsExists = (productType: string) => {
  return fitInstructions.hasOwnProperty(productType)
}
